/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Field, Formik } from "formik";
import * as yup from 'yup';
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import TextField from 'components/Form/TextField';
import { Row, Col } from 'components/Grid';
import FileModal from 'components/FileModal';
import { Label } from "components/Form";
import TagsList3 from "components/TagList3";
import { LostCancelButton } from 'components/index';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Scrollbox, ButtonContent, PlaceHolder, TagInput, BorderSwitch, RowDisplayHighlightPdf } from './styles';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import Switch from 'react-switch';
import Colors from 'constants/Colors';
import { useHeaderNbi, useGetEditWordingUrl, useWordingHtmlModal, useGetDocuments, useGetSchedulleAssumptions} from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService'; 

export default function WordingRequest(props) {
  const [summary, setSummary] = useState({});
  const [file, setFile] = useState();
  const [historymsg, setHistorymsg] = useState([]);
  const [isDisable, setIsDisable] = useState(true);
  const [editUrl, setEditUrl] = useState("");
  const [scheduleAssumptionsFile, setScheduleAssumptionsFile] = useState({});
  const [wordingFile, setWordingFile] = useState({});
  const [wordingAttachmentFile, setWordingAttachmentFile] = useState({});
  const [counter, setCounter] = useState(0);
  const [isBound, setIsBound] = useState(false);
  const [displayHighlightinPdf, setDisplayHighlightinPdf] = useState(true)

  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  fitinsur.setAuthToken(authContext.token);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useGetEditWordingUrlData,
    loading: useGetEditWordingUrlLoading,
    error: useGetEditWordingUrlError,
    status: useGetEditWordingUrlStatus,
    request: useGetEditWordingUrlRequest,
  } = useGetEditWordingUrl(props.match.params.idOperation);

  const {
    data: useWordingHtmlModalData,
    loading: useWordingHtmlModalLoading,
    error: useWordingHtmlModalError,
    status: useWordingHtmlModalStatus,
    request: useWordingHtmlModalRequest,
  } = useWordingHtmlModal(props.match.params.idOperation);

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    error: useGetDocumentsError,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest,
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useGetSchedulleAssumptionsData,
    loading: useGetSchedulleAssumptionsLoading,
    error: useGetSchedulleAssumptionsError,
    status: useGetSchedulleAssumptionsStatus,
    request: useGetSchedulleAssumptionsRequest,
  } = useGetSchedulleAssumptions(props.match.params.idOperation);

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  useEffect(() => {
    if (useHeaderNbiLoading || useGetEditWordingUrlLoading || useWordingHtmlModalLoading || useGetDocumentsLoading || useGetSchedulleAssumptionsLoading || useOperationInfoLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useGetEditWordingUrlLoading, useWordingHtmlModalLoading, useGetDocumentsLoading, useGetSchedulleAssumptionsLoading, useOperationInfoLoading]);

  const [lostDeal, setLostDeal] = useState({
    formated: [],
    array: [],
  });

  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    icon: "times-circle",
    args: null,
  });

  const HandleLostSubmit = (selectedID, array, argsContext) => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.updateQuoteEdit(props.match.params.idOperation, selectedID.reasons).then(x => x.json()).then(res => {
      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      setDialog({ visible: false, title: null, icon: null, args: null });
      history.push('/list');
    })
  };

  function handleSendApproval(policyPackMessage) {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingSendApproval(props.match.params.idOperation, policyPackMessage)
      .then(resp => resp.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        history.push(`/broking/approval-policy-pack/${props.match.params.idOperation}`);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSendApproval.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleModal() {
    useWordingHtmlModalRequest().then(({data}) => {
        setFile(data.ret_value.policePackReturnDocs);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleModal.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });
  };

  async function handleGetFiles() {
    useGetDocumentsRequest().then(({data: response}) => {
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details);
          return;
        }

        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setWordingFile({
            dsTypeDocument: file.dsTypeDocument || "Wording",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return response.ret_value;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });

      useGetDocumentsRequest(null, {isDefaultAttachment: true}).then(({data: response}) => {
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details);
          return;
        }
        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setWordingAttachmentFile({
            dsTypeDocument: file.dsTypeDocument || "Wording",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument,
            showTrash: true
          });
        } else {
          setWordingAttachmentFile({})
        }
        return response.ret_value;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${fitinsur.requestGetDocuments.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });

      useGetSchedulleAssumptionsRequest().then(({data: response}) => {
        if (response.ret_code !== 200) {
          mc.error(response.ret_msg_details);
          return;
        }
        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setScheduleAssumptionsFile({
            dsTypeDocument: "Schedule",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${fitinsur.requestAttachAssumptions.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  function handleEnablePolicyPack() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetEnablePolicy(props.match.params.idOperation).
      then(data => data.json()).
      then(resp => {
        if (resp.ret_code !== 200) {
          mc.erro(resp.ret_msg_detail);
          return;
        };

        if ("isEnabledBtnPolicyPack" in resp.ret_value) {
          if (resp.ret_value.isEnabledBtnPolicyPack) {
            setIsDisable(false);
          } else {
            setTimeout(() => setCounter(counter + 1), 2500);
          }
        };
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleEnablePolicyPack.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  async function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
        });

        setHistorymsg(data.ret_value.historical);
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  async function getEditUrl() {
    useGetEditWordingUrlRequest().then(({data: resp}) => {
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          return;
        }
        setEditUrl(`${resp.ret_value}?renderComponents=true&displayHighlightInPdf=true`);
      }).
      catch((error) => {
        mc.error(`There was an error while fetching your data: ${getEditUrl.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });
  }

  function handleRmvAttach(file) {
    loading.start();
    const idDocument = file.idDocument

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestWordingDelAttach(props.match.params.idOperation, idDocument)
      .then(data => data.json())
      .then(resp => {
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          loading.stop();
          return;
        } else {
          handleGetFiles();
        }
      })
      .catch(err => {
        mc.error("An error happened, please try again");
        loading.stop();
      });
  };

  async function handleImport(file) {
    const formData = new FormData();

    formData.append('fileDocument', file)
    formData.append('idOperation', props.match.params.idOperation)
    formData.append('isDefaultAttachment', "true")

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestWordingUpload(formData)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error(res.ret_msg_details);
          loading.stop();
          return;
        }
      })
      .then(_ => handleGetFiles())
      .catch(err => {
        mc.error("An error happened, please try again");
        loading.stop();
      });
  };

  function handleBack() {
    history.goBack();
  };

  function handleEditWording() {
    window.open(editUrl, '_blank');
  };

  function handleMktCompostion() {
    history.push(`/broking/market-composition/${props.match.params.idOperation}`)
  };

  async function handleOperationInfo() {
    useOperationInfoRequest().then(({data: response}) => {
        setIsBound(response?.isBound);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
      });
  }

  useEffect(() => {
    if (counter > 0 && isDisable) {
      handleEnablePolicyPack();
    }
  }, [counter])

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    getEditUrl();
    handleModal();
    handleSummary();
    handleGetFiles();
    handleEnablePolicyPack();
    handleOperationInfo();
  }, [])

  useEffect(() => {
    if(editUrl.includes('displayHighlightInPdf=true')){
      setEditUrl(editUrl.replace('displayHighlightInPdf=true', `displayHighlightInPdf=${displayHighlightinPdf}`))  
    } 
    if(editUrl.includes('displayHighlightInPdf=false')){
      setEditUrl(editUrl.replace('displayHighlightInPdf=false', `displayHighlightInPdf=${displayHighlightinPdf}`))
    }
  }, [displayHighlightinPdf])

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"}>
        <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} /> 
      <Formik
        validationSchema={{}}
        initialValues={{ reasons: "" }}
        onSubmit={(e) => HandleLostSubmit(e, lostDeal.array, dialog.args)}
      >
        {formikProps => (
          <>
            <Scrollbox>
              <BrokingSummary data={summary ? summary : ''} />
              <ContentCard title="Endorsement – Declaration / Policy Pack" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
                <FileModal idOperation={props?.match?.params?.idOperation} idOperation={props?.match?.params?.idOperation} file={file} summary={summary} />
                {!wordingAttachmentFile || !wordingAttachmentFile.nameFile ? <Row>
                  <Col md={2}>
                    <ButtonContainer>
                      <PlaceHolder htmlFor="fileInput">UPLOAD FILE</PlaceHolder>
                      <TagInput
                        disabled={wordingAttachmentFile && wordingAttachmentFile.nameFile}
                        type="file"
                        id="fileInput"
                        multiple={false}
                        onChange={(event) => { handleImport(event.target.files[0]) }}
                      />
                    </ButtonContainer>
                  </Col>
                </Row> : <></>}

                <Row >
                  {wordingFile && wordingFile.nameFile || scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile ||
                    wordingAttachmentFile && wordingAttachmentFile.nameFile ?
                    <Col md={9} sm={1} style={{ marginBottom: 20, marginTop: 10 }}>
                      <Label>Attachments</Label>
                      <TagsList3
                        tags={[wordingAttachmentFile, wordingFile, scheduleAssumptionsFile].filter(file => file.nameFile)}
                        disableType
                        hideTrash={true}
                        removeTag={(index) => handleRmvAttach(wordingAttachmentFile)}
                      />
                    </Col>
                    : ''}
                </Row>

              <RowDisplayHighlightPdf>
                    <Label style={{ fontWeight: 300, fontSize: 15 }}>
                    Highlight changes in the PDF
                    </Label>
                    <BorderSwitch>
                      <Field
                        component={Switch}
                        height={27}
                        width={55}
                        name={'lock'}
                        checked={displayHighlightinPdf}
                        onChange={(e) => {
                          setDisplayHighlightinPdf(e);
                        }}
                        checkedIcon={false}
                        uncheckedIcon={false}
                        handleDiameter={20}
                        offColor={Colors.WHITE}
                        onColor={Colors.GRAY[6]}
                        offHandleColor={Colors.GRAY[6]}
                        onHandleColor={Colors.WHITE}
                      />
                    </BorderSwitch>
              </RowDisplayHighlightPdf>

                <ButtonContainer >
                  <Button forth onClick={() => handleBack()}>&lt; Back</Button>
                  <HasPermission permission={!isBound}>
                    <RenderButtons idOperation={props.match?.params?.idOperation}>
                      <ButtonContent >
                        <div style={{ marginTop: "5px" }}>
                          <LostCancelButton idOperation={props.match?.params?.idOperation} />
                        </div>
                        <HasPermission permission={props.permissions.MARKETING_COMPOSITION}>
                          <Button third style={{ marginLeft: "10px", marginTop: "5px" }} onClick={() => handleMktCompostion()}>
                            CDR
                          </Button>
                        </HasPermission>
                        <HasPermission permission={props.permissions.GENERATE_WORDING}>
                          <Button primary style={{ marginLeft: "10px", marginTop: "5px" }} onClick={() => {
                            handleEditWording()
                          }}>
                            EDIT WORDING
                          </Button>
                        </HasPermission>
                        <HasPermission permission={props.permissions.SEND} >
                          <Button primary style={{ marginLeft: "10px", marginTop: "5px" }} disabled={isDisable} onClick={async () => {
                            history.push(`/broking/send-order-to-bind/${props.match.params.idOperation}`)
                          }}>
                            ORDER TO BIND
                          </Button>
                        </HasPermission>
                      </ButtonContent>
                    </RenderButtons>
                  </HasPermission>
                </ButtonContainer>
              </ContentCard>
            </Scrollbox>
          </>)}
      </Formik>
    </Layout>
  )
}
